import React, { Component } from 'react'
import '../css/dataTables.css';
import $ from 'jquery';
import { DataTablesCreate } from './index'

const headers = [
    { title: 'N° doc.' },
    { title: 'Tipo de atención' },
    { title: 'Cliente' },
    { title: 'Dirección' },
    { title: 'Fecha' },
    // { title: 'Documento' },
    // { title: 'Total' },
    // { title: 'Folio' },
    // { title: 'Días de atraso' },


];

class ListDocsDeliveries extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchInTable: '',
        }
    }

    componentDidMount() {
        const { cleanData } = this.props;

        this.CloseAction();
    }

    CloseModal = async () => {
        $('#pendingDeliveries').modal('hide');
    };

    CloseAction = () => {
        const { cleanData } = this.props;
        $('#pendingDeliveries').on('hidden.bs.modal', () => {
            cleanData();
        });
    };


    AddLinesToDocument = () => {
        $('#pendingDeliveries').modal('hide');
        this.props.selectItemsToArray();
    }


    render() {
        const { data, selectItems, showAlert, search, selectItemsToArray } = this.props;
        return (
            <div className="modal fade bd-example-modal-lg modal-open scroll bgtransparent" role="dialog" id="pendingDeliveries" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-xl modal-open" role="document">
                    <div className="modal-content">

                        <div className="modal-header text-white" style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title ">DOCUMENTOS PENDIENTES DE ENTREGA A CLIENTE</h4>
                            <button type="button" className="close" onClick={this.CloseModal} aria-label="Close">
                                <span className="text-white" aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div className="modal-body">
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div className="table-responsive">
                                            <table className="table response" style={{ marginBottom: 0 }}>
                                                <tbody>
                                                    <DataTablesCreate
                                                        data={data}
                                                        headers={headers}
                                                        view={"pendingDeliveries"}
                                                        action={selectItems}
                                                        showAlert={showAlert}
                                                        flagInvoices={false}
                                                        search={search}
                                                        filterByDate={false}
                                                    />
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white" onClick={this.CloseModal}>Cerrar</button>
                            <button type="button" className="btn botonCorrect" onClick={() => this.AddLinesToDocument()}>Agregar</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


export default ListDocsDeliveries;